<banner-app
  [Fixtop]="''"
  [retroSelected]="true"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>

<div class="mainContainer justify-content-center align-items-center">
  <div class="titleContainer d-flex flex-column align-items-center">
    <h3 class="title">Este seguro no es el SOAT</h3>
  </div>
  <div class="subtitleContainer d-flex flex-column">
    <h5 class="subtitle">
      Al continuar estarás adquiriendo un Seguro complementario contra hurtos o
      daños.
    </h5>
  </div>

  <img
    src="./assets/img/paletero.png"
    class="image"
    alt="seguro de moto precio" 
    loading="lazy"
  />

  <div class="buttonsContainer d-flex justify-content-center">
    <button
      class="btn btn-primary localButton backStartButton"
      type="submit"
      (click)="continuar()"
    >
      <strong>Continuar</strong>
    </button>
  </div>
  <div class="soatContainer mb-5">
    <a
      href="https://www.sura.co/seguros/personas/movilidad/soat"
      class="linkText"
      (click)="pushDataLayer('Button', 'Quiero comprar SOAT')"
      >Quiero comprar SOAT</a
    >
  </div>
</div>

<app-footer-app class="footer-fixed" />
